import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { steps } from '../../data/content';
export function HowItWorks() {
  return <section className="w-full bg-cream" data-id="element-205" data-mp="3k2or3biwt755">
      <div className="mx-auto w-full max-w-content px-5 py-14 sm:px-8 sm:py-20" data-id="element-206" data-mp="2t8jvkz89ilr">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-teal" data-id="element-207" data-mp="3txyvg5ws5qm3">
          Il sistema
        </p>
        <h2 className="mt-3 text-balance text-center font-display text-[30px] font-black leading-[1.1] tracking-[-0.02em] text-plum-deep sm:text-4xl" data-id="element-208" data-mp="brkhi6yihgnp">
          Ecco come funziona il Progetto
        </h2>

        <ol className="mt-10 space-y-5 lg:grid lg:grid-cols-2 lg:gap-6 lg:space-y-0" data-id="element-209" data-mp="li5i1zxqwv99">
          {steps.map(step => <li key={step.number} className="relative flex flex-col rounded-3xl bg-white p-5 ring-1 ring-ink/10 sm:p-7" data-id="element-210" data-mp="glopmtjijuqd">
              <div className="flex items-center gap-3" data-id="element-211" data-mp="qj2v5y3wez3w">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-plum font-display text-xl font-black text-white" data-id="element-212" data-mp="24ch58isrpqk6">
                  {step.number}
                </span>
                <span className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-teal" data-id="element-213" data-mp="2dd5j9di5vqx2">
                  {step.kicker}
                </span>
              </div>

              <h3 className="mt-4 font-display text-[22px] font-black leading-tight text-plum-deep sm:text-2xl" data-id="element-214" data-mp="2i9m8yc50edc9">
                {step.title}
              </h3>

              <p className="mt-3 text-[15px] leading-relaxed text-ink/70 sm:text-base" data-id="element-215" data-mp="2rbc8k591oil4">
                {step.body}
              </p>

              {step.list ? <ul className="mt-4 space-y-2" data-id="element-216" data-mp="312zwhw6e7hhu">
                  {step.list.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-217" data-mp="36232pjy3ztre">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-218" data-mp="35zqc6ieacb2q" />
                      <span className="text-[14.5px] font-medium text-ink/75" data-id="element-219" data-mp="3ay9w6d9bjcsg">{item}</span>
                    </li>)}
                </ul> : null}

              <div className="mt-auto pt-5" data-id="element-220" data-mp="2gf8omfly191k">
                {step.highlights.map(line => <p key={line} className="text-[15px] font-bold text-plum sm:text-base" data-id="element-221" data-mp="2v3mqan7mirgj">
                    {line}
                  </p>)}
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-222" data-mp="344tb38hb2ofl">
          <CTAButton label="Inizia a seguire questi 4 passaggi oggi" sub="Accesso immediato • Accesso a vita" variant="plum" data-id="element-223" data-mp="2z2vkft6ksrcm" />
        </div>
      </div>
    </section>;
}